var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-group-form-page',{attrs:{"resource-name":_vm.resourceName,"url":`projects/${_vm.project_id}/searches/`,"item_id":null,"item":_vm.model,"title":_vm.$t('booleanSearch.new_bool_query'),"is-busy":_vm.isBusy}})
}
var staticRenderFns = []

export { render, staticRenderFns }